module.exports = __webpack_public_path__ + "img/eraser30.c6be6fea.png";